import dynamic from "next/dynamic";
import { GamesCardListSkeleton } from "@/components/webview/games/core/GamesCardListSkeleton";
import { useTrans } from "@/utils/useTrans";
import { LayoutGamesWebView } from "@/components/webview/games/layout/LayoutGamesWebView";
import { GamesPlatformWebView } from "@/components/webview/games/constants/gameResellWebViewConstants";
import Link from "next/link";
import { WEBVIEW_ROUTES } from "@/components/webview/route";
import { Button1 } from "@/components/webview/games/typograpy/typograpy-webview";

const LazyGamesNewGamesWebView = dynamic<{
  className?: string;
  platform?: GamesPlatformWebView;
}>(() => import("../GamesNewGamesWebView"), {
  ssr: false,
  loading: () => (
    <LayoutGamesWebView
      className={"py-4"}
      header={<h2 className="px-4">{"New Games"}</h2>}
      contents={<GamesCardListSkeleton cardCount={9} cardWidth={"w-[100px]"} />}
    />
  ),
});

const SimRacingLazySectionsWebView = () => {
  const { t } = useTrans(["games"]);
  return (
    <div className="flex flex-col gap-[38px] bg-black">
      <LazyGamesNewGamesWebView platform={GamesPlatformWebView.Simracing} />

      <LayoutGamesWebView
        className="px-4 pb-10"
        contents={
          <Link
            href={`${WEBVIEW_ROUTES.webviewSearch}/?filter=${GamesPlatformWebView.Simracing}&sort=monthlyPlayCount&only-sellable=false`}
            className="flex h-[50px] w-full items-center justify-center rounded-md bg-[#FFD900] text-black"
          >
            <Button1>{t("See All Sim Racing Games")}</Button1>
          </Link>
        }
      />
    </div>
  );
};

export default SimRacingLazySectionsWebView;
